import axios from 'axios'
import * as types from "../mutation-type"
import $httpService from '../../common/utils'

export default {
  state: {
    addressTop: {
      info: ''
    },
    tokenTop: {
      info: ''
    },
  },
  mutations: {
    [types.SET_ADDRESS_TOP](state, payload) {
      state.addressTop.info = payload.info
    },
    [types.SET_TOKEN_TOP](state, payload) {
      state.tokenTop.info = payload.info
    }
  },
  actions: {
    getAddressTop({dispatch, commit},$param) {
        if($param.topType == "ont"){
            $param.topID = '1,2,3,4'
        }
        if($param.topType == "ong"){
            $param.topID = '5,6,7,8'
        }
        if($param.topType == "network"){
            $param.topID = '9,13'
        }
        if($param.topType == "overview"){
            $param.topID = ''
        }
      return $httpService.get('/addresses/rankings?ranking_id='+$param.topID+'&duration='+$param.topDuration).then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_ADDRESS_TOP,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getTokenTop({dispatch, commit},$param) {

        if($param.topType == "token"){
            $param.topID = '9,10,11,12'
        }
        if($param.topType == "overview"){
            $param.topID = ''
        }
      return $httpService.get('/tokens/rankings?ranking_id='+$param.topID+'&duration='+$param.topDuration).then(response => {
        if(response.code === 0) {
          commit({
            type: types.SET_TOKEN_TOP,
            info: response.result
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/top.js